import commonWords from './commonWords.esm.js';
import firstnames from './firstnames.esm.js';
import lastnames from './lastnames.esm.js';
import wikipedia from './wikipedia.esm.js';
import translations from './translations.esm.js';

var index = {
  dictionary: {
    commonWords,
    firstnames,
    lastnames,
    wikipedia
  },
  translations
};

export { index as default };
//# sourceMappingURL=index.esm.js.map
